<template>
  <div class="container my-5">
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <form @submit.prevent="logIn">
          <div class="form-group">
            <label for="login">Login</label>
            <input
              type="text"
              class="form-control"
              id="login"
              v-model="login"
            />
          </div>
          <div class="form-group">
            <label for="password">Hasło</label>
            <input
              type="password"
              class="form-control"
              id="password"
              v-model="password"
            />
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary">Zaloguj się</button>
            <p v-if="isFailed" class="failed-warning">
              Logowanie nie powiodło się
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: "",
      password: "",
      isFailed: false,
    };
  },
  methods: {
    logIn: function () {
      let data = { username: this.login, password: this.password };
      this.$api.login(data).then((response) => {
        if (response.ok) {
          this.isFailed = false;
          localStorage.isSignedIn = true;
          localStorage.token = response.data.token;
          this.$store.isSignedIn = true;
          this.$router.push({ name: "Building" });
        } else {
          this.isFailed = true;
        }
      });
    },
  },
};
</script>
<style>
</style>